import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { formatApiError } from "@/lib/errors";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const params = new URLSearchParams(loc.search);
  const redirect = params.get("from") || "/challenges";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await login(email, password);
      nav(redirect);
    } catch (err) {
      setError(formatApiError(err));
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-20" data-testid="login-page">
      <div className="label-mono mb-3">Access</div>
      <h1 className="font-display font-black uppercase text-4xl tracking-tighter mb-8">Sign in</h1>
      <form onSubmit={onSubmit} className="card p-8 space-y-4">
        <div>
          <label className="label-mono block mb-2">Email</label>
          <input className="input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email-input" />
        </div>
        <div>
          <label className="label-mono block mb-2">Password</label>
          <input className="input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password-input" />
        </div>
        {error && <div className="tag tag-wrong block" data-testid="login-error">{error}</div>}
        <button className="btn btn-primary w-full" disabled={loading} data-testid="login-submit-button">
          {loading ? "Signing in…" : "Sign in"}
        </button>
        <div className="label-mono text-center pt-2" style={{ color: "var(--text-dim)" }}>
          No account? <Link to="/register" className="underline" data-testid="login-to-register-link">Create one</Link>
        </div>
      </form>
    </div>
  );
}
